<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-4">
                <h2 class="h h--2 h--dark">Historia złotówek</h2>
                <p class="paragraph">Tabela prezentuje historię zgromadzonej przez Ciebie puli pieniędzy. Dzięki niej dowiesz się ile złotówek zgromadziłeś i kiedy zostały Ci przyznane.</p>
            </div>
            <div class="col-12 col-lg-8" v-bind:class="{'pending': pagination.pending}">
                <div v-if="moneys.length > 0">
                  <table class="invoices__table">
                      <tr>
                          <th>liczba złotówek</th>
                          <th>opis</th>
                          <th>data dodania</th>
                      </tr>
                      <tr v-for="item in moneys" :key="item.id">                 
                          <td>{{ item.difference }}</td>
                          <td>{{ item.description }}</td>
                          <td>{{ item.created_at }}</td>
                      </tr>
                  </table>
                  <pagination v-model="pagination.current_page" :page="pagination.current_page" :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate" v-if="pagination && pagination.last_page > 1"></pagination>
                </div>
                <div class="row profile" v-if="moneys.length == 0">
                    <div class="col col-12">
                        <p>brak wpisów w historii</p>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'MoneysComponent',
  data () {
    return {
      moneys: [],
      pagination: {}
    }
  },
  beforeRouteEnter(to, from, next) {      
    /**
     * Get moneys.
     */
    Vue.axios({
      method: 'get',
      url: '/users/current/moneyHistory'
    })
    .then(response => {
        next(vm => {
          vm.moneys = response.data.data.moneys
          vm.pagination = response.data.pagination
        })
    })
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/zlotowki',
        })
    }
  },
  methods: {
    /**
     * On change paginate event.
     * 
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this

      vm.pagination.pending = true

      Vue.axios({
        method: 'get',
        url: '/users/current/moneyHistory',
        params: {
          page: page
        }
      })
      .then(response => {
        vm.moneys = response.data.data.moneys
        vm.pagination = response.data.pagination
      })
      .catch(error => vm.pagination.pending = false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/moneys/MoneysComponent.vue